import { LuruReduxStore } from '../../../app/store'

export const isNoteDraft = (noteId: string) => {
  var state = LuruReduxStore.getState()
  return Boolean(state.notes.entities[noteId]?.isDraft)
}
